// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue';
import VueGtm from 'vue-gtm';
import axios from 'axios';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import './utils/filters';
import App from './App';
import router from './router';
import AppConfig from './components/plugins/AppConfig';

Vue.use(AppConfig);

Raven.config(Vue.$appsettings.TrackerClientDSNKey)
  .addPlugin(RavenVue, Vue)
  .install();

Vue.use(VueGtm, {
  enabled: true,
  debug: false,
  vueRouter: router,
});

Vue.config.productionTip = false;

// Initialize a separate Vue instance to handle state between components
// We use the photoClaim namespace to avoid global naming conflicts
window.photoClaim = new Vue({
  data() {
    return {
      errors: [],
      identifier: null,
      secondaryIdentifier: null,
      visits: localStorage.getItem('visits') ? Number(localStorage.getItem('visits')) : 0, // initially, set to 0. Otherwise, get from local storage
      isFromHomeScreen: false,
      hasSeenIOSPrompt: localStorage.getItem('hasSeenIOSPrompt')
        ? localStorage.getItem('hasSeenIOSPrompt')
        : false, // get from localStorage, or default to false
      iOSPromptViewCount: localStorage.getItem('iOSPromptViewCount')
        ? Number(localStorage.getItem('iOSPromptViewCount'))
        : 0,
      isIOS: !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform),
      devMessage: '',
      showIOSPrompt: false,
      imageTypesWhitelist: ['bmp', 'gif', 'png', 'jpeg', 'jpg', 'webp', 'tiff', 'heif', 'hevc', 'pdf'],
    };
  },
  watch: {
    visits(val) {
      localStorage.setItem('visits', val);
    },
    hasSeenIOSPrompt(val) {
      localStorage.setItem('hasSeenIOSPrompt', val);
    },
    iOSPromptViewCount(val) {
      localStorage.setItem('iOSPromptViewCount', val);
    },
  },
  created() {
    // Read Image File Type whitelist
    axios
        .get(`${this.$appsettings.APIUrl}/files/whitelist?categories=3`)
        .then((result) => {
          if (result.status === 200) {
            this.imageTypesWhitelist = result.data;
          }
        })
        .catch(err => {
          // Emit error to sentry
          Raven.setExtraContext({ error: 'Failed to retrieve image whitelist' });
          Raven.captureException(err);
        });
  },
});

// Our default app vue instance
const app = new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js